import React, { Component } from "react";
import {
  Box,
  Button,
  CardHeader,
  Dialog,
  Divider,
  Fade,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography
} from "@material-ui/core";
import { ArrowForwardIos, Close } from "@material-ui/icons";
import PropTypes from "prop-types";

export default class CGU extends Component {
  state = {
    openModal: false,
    openModalStart: true,
    showDetails: false
  };

  handleOpenModalCGU = () => {
    return this.setState({ openModal: true });
  };

  handleCloseModalCGU = () => {
    return this.setState({ openModal: false });
  };
  render() {
    const { cguData, consignesData } = this.props;
    return (
      <>
        <Box
          sx={{
            margin: 10,
            borderRadius: "8px",
            bgcolor: "white",
            height: "100%",
            color: "white",
            border: "1px solid #C8C8C8",
            marginTop: "16px",
            paddingTop: "16px"
          }}
        >
          <Typography
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "16px",
              marginRight: 20,
              marginLeft: 16,
              color: "#212121"
            }}
          >
            <img
              src="icons/consigneIcon.svg"
              alt="icon"
              width={22}
              style={{ marginRight: 8 }}
            />
            Mes consignes
          </Typography>
          <List
            sx={{
              width: "100%",
              maxWidth: 360,
              bgcolor: "background.paper"
            }}
          >
            {consignesData.map((item, key) => {
              return (
                <div key={key}>
                  <ListItem alignItems="flex-start" key={key}>
                    <ListItemText
                      style={{ color: "#212121" }}
                      primary={
                        <div
                          style={{ textAlign: "justify" }}
                          dangerouslySetInnerHTML={{ __html: item.name }}
                        />
                      }
                      secondary={
                        <span
                          style={{ textAlign: "justify" }}
                          dangerouslySetInnerHTML={{ __html: item.contenu }}
                        />
                      }
                    />
                  </ListItem>
                  <Divider variant="middle" component="li" />;
                </div>
              );
            })}
          </List>
          <Button
            onClick={this.handleOpenModalCGU}
            edge={"start"}
            endIcon={<ArrowForwardIos style={{ height: 15 }} />}
            style={{
              width: "100%",
              color: "#009EFF",
              backgroundColor: "white",
              borderRadius: "0 0 8px 8px",
              borderTop: "1px solid #C8C8C8",
              textTransform: "none"
            }}
          >
            Lire les CGU
          </Button>

          <Dialog
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={this.state.openModal}
            onClose={this.handleCloseModalCGU}
            closeAfterTransition
          >
            <Fade in={this.state.openModal}>
              <Box style={{ padding: 0, margin: 0 }}>
                <CardHeader
                  subheader={
                    <Typography style={{ color: "white" }}>
                      {`Conditions générales d'utilisation`}
                    </Typography>
                  }
                  action={
                    <IconButton
                      style={{
                        color: "white",
                        height: "10px",
                        width: "10px"
                      }}
                      onClick={this.handleCloseModalCGU}
                      aria-label="close"
                    >
                      <Close />
                    </IconButton>
                  }
                  style={{
                    fontSize: "11px",
                    color: "white",
                    backgroundColor: "#009EFF",
                    borderRadius: "7px 7px 0 0",
                    height: "8px"
                  }}
                />
                <Box
                  id="body"
                  style={{
                    paddingLeft: "19px",
                    paddingRight: "19px",
                    height: "100%",
                    maxHeight: 400,
                    overflow: "hidden",
                    overflowY: "scroll"
                  }}
                >
                  <Typography variant="body1">
                    <div
                      style={{ textAlign: "justify" }}
                      dangerouslySetInnerHTML={{ __html: cguData }}
                    />
                  </Typography>
                </Box>
              </Box>
            </Fade>
          </Dialog>
        </Box>
      </>
    );
  }
}
CGU.propTypes = {
  cguData: PropTypes.any,
  consignesData: PropTypes.array
};
